import React, { useCallback, useEffect, useState } from "react";
import styles from './index.module.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { faCalendar, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BrandImg from "../../../assets/images/tickets/mahajana sampatha logo@3x.png";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllActiveResults } from "../../../redux/features/result/resultServices";
import Capricom from "../../../assets/images/astro/1.png";
import Aquarius from "../../../assets/images/astro/2.png";
import Pisces from "../../../assets/images/astro/3.png";
import Aries from "../../../assets/images/astro/4.png";
import Taurus from "../../../assets/images/astro/5.png";
import Gemini from "../../../assets/images/astro/6.png";
import Cancer from "../../../assets/images/astro/7.png";
import Leo from "../../../assets/images/astro/8.png";
import Virgo from "../../../assets/images/astro/9.png";
import Libra from "../../../assets/images/astro/10.png";
import Scorpio from "../../../assets/images/astro/11.png";
import Sagittarius from "../../../assets/images/astro/12.png";
import SkeletonLotteryResultCard from "../../Skeleton/LotteryResultCardSkeleton";
import NoResultsFoundImg from "../../../assets/images/No-resultz-Found.png";

const astroImages = {
    1: Capricom,
    2: Aquarius,
    3: Pisces,
    4: Aries,
    5: Taurus,
    6: Gemini,
    7: Cancer,
    8: Leo,
    9: Virgo,
    10: Libra,
    11: Scorpio,
    12: Sagittarius,
};

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const WinningResults = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const { isResultsLoading, results } = useSelector((state) => state.result.allActiveResults);

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const [selectedDate, setSelectedDate] = useState(yesterday);
    const [selectedDraw, setSelectedDraw] = useState(null);

    const fetcResults = useCallback(
        (filters = {}) => {
            const params = {
                skip: 1,
                draw_date: formatDate(selectedDate),
                draw_no: selectedDraw,
                limit: 25,
                ...filters,
            };
            dispatch(getAllActiveResults(params));
        },
        [dispatch, selectedDate, selectedDraw]
    );

    useEffect(() => {
        fetcResults();
    }, [fetcResults]);

    const resetResults = () => {
        setSelectedDate(yesterday);
        setSelectedDraw(null);
    }
    
    return (
        <div className={styles.resultsContainer}>
            <div className={`main-container`}>
                <div className={`container-content`}>
                    <div className={styles.homeHeader}>
                        <h1 className={styles.listingTitle}>{t(`Winning Results`)}</h1>
                    </div>
                    <div className={styles.resultsForm}>
                        <div className={styles.searchRow}>
                            <div>
                                <div className={styles.label}>{t(`Date`)}</div>
                                <DatePicker
                                    showIcon
                                    selected={selectedDate}
                                    onChange={(date) => setSelectedDate(date)}
                                    icon={faCalendar}
                                    className={styles.dateSelector}
                                    maxDate={yesterday} />
                                {/* <input type="date" className={styles.drawInput}
                                    placeholder="Draw Date"
                                    onChange={(date) => setStartDate(date)}
                                /> */}
                            </div>
                            <div className={styles.mobileRow}>
                                <div>
                                    <div className={styles.label}>{t(`Draw`)}</div>
                                    <input type="text" className={styles.drawInput}
                                        placeholder="Draw Number"
                                        onChange={(e) => setSelectedDraw(e.target.value)} />
                                </div>
                                <div>
                                    <div className={styles.label}></div>
                                    <button type="button" className={`${styles.resetBtn} ${i18n.language === 'si' ? `si-text` : i18n.language === 'ta' ? `ta-text` : ""}`} onClick={resetResults}>{t(`Reset`)}</button>
                                    <button type="button" className={styles.resetMobileBtn} onClick={resetResults}><FontAwesomeIcon icon={faRefresh} /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.resultsCardSection}>
                        {isResultsLoading? Array.from({ length: 3 }).map((_, idx) => (
                            <SkeletonLotteryResultCard key={idx} />
                        )) :
                         results.length > 0 ?
                            results?.map((result) => (
                                <div className={styles.resultCard} key={result.id}>
                                    <div className={styles.ticketDetails}>
                                        <img src={result.lottery.lottery_brand_day.lottery_brand.logo_url} alt="logo" className={styles.logoImg} />
                                        <p className={styles.pricetitle}>{t(`Next super Prize`)}</p>
                                        <p className={styles.prize}>{t(`Rs`)} {result.next_mega_prize}</p>
                                        <p className={styles.brandName}>{t(result.lottery.lottery_brand_day.lottery_brand.name)}</p>
                                        <div className={styles.detailsRow}>
                                            <p className={styles.rowText}>{t(`Draw`)}: {result.lottery.draw_no}</p>
                                            <p className={styles.rowText}>{t(`Date`)}: {result.lottery.draw_date}</p>
                                        </div>
                                    </div>
                                    <div className={`${styles.resultsSection} ${styles[`resultsSection${result.code}`]}`}>
                                        <div className={styles.ticketDetails}>
                                            {result.lottery.lottery_brand_day.lottery_brand.code === 'MASAM' &&
                                                <div className={styles.masamNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{result.masam_result.char}</p>
                                                    {result.masam_result.recd.split("").map((char, index) => (
                                                        <p key={index} className={styles.masamResultNumber}>{char}</p>
                                                    ))}
                                                </div>
                                            }
                                            {result.lottery.lottery_brand_day.lottery_brand.code === 'MEPO' &&
                                                <div className={styles.masamNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{result.mepo_result.char}</p>
                                                    <p className={styles.masamResultSpNumber}>{result.mepo_result.sno.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{result.mepo_result.n1.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{result.mepo_result.n2.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{result.mepo_result.n3.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{result.mepo_result.n4.padStart(2, '0')}</p>
                                                </div>
                                            }
                                            {result.lottery.lottery_brand_day.lottery_brand.code === 'ADSA' &&
                                                <div className={styles.adsaNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{result.adsa_result.char}</p>
                                                    <p className={`${styles.adsaResultNumberA} ${styles.masamResultNumber}`}>{result.adsa_result.arange.padStart(2, '0')}</p>
                                                    <p className={`${styles.adsaResultNumberB} ${styles.masamResultNumber}`}>{result.adsa_result.brange.padStart(3, '0')}</p>
                                                    <p className={`${styles.adsaResultNumberC} ${styles.masamResultNumber}`}>{result.adsa_result.crange.padStart(4, '0')}</p>
                                                </div>
                                            }
                                            {result.lottery.lottery_brand_day.lottery_brand.code === 'DHNI' &&
                                                <>
                                                    <div className={styles.adsaNumberRow}>
                                                        <p className={styles.dhniResultsLetter}>{result.dhni_result.char1}</p>
                                                        <p className={styles.dhniResultNumber}>{result.dhni_result.n1.padStart(2, '0')}</p>
                                                        <p className={styles.dhniResultNumber}>{result.dhni_result.n2.padStart(2, '0')}</p>
                                                        <p className={styles.dhniResultNumber}>{result.dhni_result.n3.padStart(2, '0')}</p>
                                                        <p className={styles.dhniResultNumber}>{result.dhni_result.n4.padStart(2, '0')}</p>
                                                    </div>
                                                    <div className={styles.adsaNumberRow}>
                                                        {/* <p className={styles.dhniResultsLetter}>{result.dhni_result.char2}</p> */}
                                                        <p className={styles.dhniResultNumberSp}>{result.dhni_result.special.padStart(5, '0')}</p>
                                                    </div>
                                                </>
                                            }
                                            {result.lottery.lottery_brand_day.lottery_brand.code === 'GOVI' &&
                                                <div className={styles.masamNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{result.govi_result.char1}</p>
                                                    {result.govi_result.char2 && <p className={styles.masamResultsLetter}>{result.govi_result.char2}</p>}
                                                    <p className={styles.masamResultNumber}>{result.govi_result.n1.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{result.govi_result.n2.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{result.govi_result.n3.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{result.govi_result.n4.padStart(2, '0')}</p>
                                                </div>
                                            }
                                            {result.lottery.lottery_brand_day.lottery_brand.code === 'HADA' &&
                                                <div className={styles.hadaCol}>
                                                    <div className={styles.hadaLeftCol}>
                                                        <img src={astroImages[result.hada_result.lagna]} alt={`Image ${result.hada_result.lagna}`} className={styles.hadaAstro} />
                                                    </div>
                                                    <div className={styles.hadaRighttCol}>
                                                        <div className={styles.adsaNumberRow}>
                                                            <p className={styles.dhniResultNumber}>{result.hada_result.n1.padStart(2, '0')}</p>
                                                            <p className={styles.dhniResultNumber}>{result.hada_result.n2.padStart(2, '0')}</p>
                                                            <p className={styles.dhniResultNumber}>{result.hada_result.n3.padStart(2, '0')}</p>
                                                            <p className={styles.dhniResultNumber}>{result.hada_result.n4.padStart(2, '0')}</p>
                                                        </div>
                                                        <div className={styles.hadaNumberRow}>
                                                            <p className={styles.hadaSpecial}>{result.hada_result.special}</p>
                                                            <p className={styles.hadaDaywaLetter}>{result.hada_result.dayn}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {result.lottery.lottery_brand_day.lottery_brand.code === 'JAYA' &&
                                                <div className={styles.jayaNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{result.jaya_result.char}</p>
                                                    {result.jaya_result.recd.split("").map((char, index) => (
                                                        <p key={index} className={styles.masamResultNumber}>{char}</p>
                                                    ))}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )) :
                            <div className={styles.noResults}>
                                <img
                                    src={NoResultsFoundImg}
                                    alt="No Results Found"
                                    className={styles.noResultsImage}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WinningResults;